(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7735],{

/***/ 67735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ab_cart_src; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(62062);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/numeral/numeral.js
var numeral = __webpack_require__(94960);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ../packages/ab-context-cart/src/index.tsx + 3 modules
var src = __webpack_require__(29359);
// EXTERNAL MODULE: ../packages/ab-context-user/src/index.tsx + 4 modules
var ab_context_user_src = __webpack_require__(38416);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var ab_text_src = __webpack_require__(145);
// EXTERNAL MODULE: ../packages/ab-input/src/index.tsx
var ab_input_src = __webpack_require__(9215);
// EXTERNAL MODULE: ../packages/ab-link/src/index.tsx
var ab_link_src = __webpack_require__(276);
// EXTERNAL MODULE: ../packages/ook-loading/src/index.tsx
var ook_loading_src = __webpack_require__(27336);
// EXTERNAL MODULE: ../packages/ab-gtm/src/datalayer.js
var datalayer = __webpack_require__(6116);
;// CONCATENATED MODULE: ../packages/ab-cart/src/CartInfoShipping.tsx


var CartInfoShipping = function(param) {
    var language = param.language;
    if (typeof language !== "string") return null;
    var info = getInfoShipping(language.toLowerCase());
    return info && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "info",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/images/info.png",
                width: 20,
                height: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                element: "span",
                style: {
                    fontSize: 11,
                    color: "#a79669",
                    fontFamily: "GT Eesti",
                    fontWeight: 300
                },
                children: info
            })
        ]
    });
};
function getInfoShipping(language) {
    var warnings = [
        {
            fromDate: "2023-08-01",
            toDate: "2023-08-16",
            info: {
                es: "Los tiempos de entrega habituales (entre 48h-72h) pueden verse afectados por fiestas locales y nacionales los d\xedas 4, 14 y 15 agosto.",
                en: "The usual delivery times (between 48h-72h) may be affected by local and national holidays on August 4, 14 and 15.",
                de: "The usual delivery times (between 48h-72h) may be affected by local and national holidays on August 4, 14 and 15."
            }
        }
    ];
    var time = function(date) {
        return date ? new Date(date).getTime() : new Date().getTime();
    };
    var todayTime = time();
    var warning = warnings.find(function(param) {
        var fromDate = param.fromDate, toDate = param.toDate;
        var fromTime = time(fromDate);
        var toTime = time(toDate);
        return todayTime > fromTime && todayTime < toTime;
    });
    if (warning && isKey(warning.info, language)) {
        return warning.info[language];
    } else {
        return null;
    }
}
function isKey(x, k) {
    return k in x;
}
/* harmony default export */ var src_CartInfoShipping = (CartInfoShipping);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../packages/ab-quantity-picker/src/index.tsx
var ab_quantity_picker_src = __webpack_require__(40322);
;// CONCATENATED MODULE: ../packages/ab-cart/src/CartItem.tsx










var CartItem = function(param) {
    var itm = param.itm, i18n = param.i18n;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
    var ref29 = (0,_sliced_to_array/* default */.Z)((0,src/* useCartContext */.iQ)(), 2), state = ref29[0], dispatch = ref29[1];
    var handleQtyChange = dispatch.handleQtyChange, handleQtyChangePersonalizacion = dispatch.handleQtyChangePersonalizacion;
    // console.log("CartItem", itm);
    var ref30 = (0,react.useState)(false), stockError = ref30[0], setStockError = ref30[1];
    if ((numeral_default()).locales.abadia === undefined) {
        numeral_default().register("locale", "abadia", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mm",
                billion: "b",
                trillion: "t"
            },
            ordinal: function ordinal(number) {
                var b = number % 10;
                return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
            },
            currency: {
                symbol: "€"
            }
        });
    }
    numeral_default().locale("abadia");
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    var getLanguageName = function(name) {
        if ((name === null || name === void 0 ? void 0 : name.toLowerCase()) == "a\xf1ada") {
            return t("anada");
        } else if ((name === null || name === void 0 ? void 0 : name.toLowerCase()) == "formato") {
            return t("formato");
        } else {
            return name;
        }
    };
    var isPersonalizacion = itm === null || itm === void 0 ? void 0 : (ref = itm.product) === null || ref === void 0 ? void 0 : (ref1 = ref.node) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sku) === null || ref2 === void 0 ? void 0 : ref2.includes("00605");
    var isEBox = itm === null || itm === void 0 ? void 0 : (ref3 = itm.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.node) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sku) === null || ref5 === void 0 ? void 0 : ref5.includes("EB0");
    var addedItemsString = (itm === null || itm === void 0 ? void 0 : (ref6 = itm.extraData) === null || ref6 === void 0 ? void 0 : ref6.length) && ((ref7 = itm === null || itm === void 0 ? void 0 : itm.extraData[0]) === null || ref7 === void 0 ? void 0 : ref7.value) ? (ref9 = JSON.parse((ref8 = itm === null || itm === void 0 ? void 0 : itm.extraData[0]) === null || ref8 === void 0 ? void 0 : ref8.value).find(function(itm) {
        return itm.name == "Que incluye";
    })) === null || ref9 === void 0 ? void 0 : ref9.value : "";
    var addedItems = addedItemsString ? addedItemsString.split(",") : [];
    var personalizacion = (itm === null || itm === void 0 ? void 0 : (ref10 = itm.extraData) === null || ref10 === void 0 ? void 0 : ref10.length) && ((ref11 = itm === null || itm === void 0 ? void 0 : itm.extraData[0]) === null || ref11 === void 0 ? void 0 : ref11.value) ? (ref13 = JSON.parse((ref12 = itm === null || itm === void 0 ? void 0 : itm.extraData[0]) === null || ref12 === void 0 ? void 0 : ref12.value).find(function(itm) {
        return itm.name == "Texto para la etiqueta";
    })) === null || ref13 === void 0 ? void 0 : ref13.value : "";
    var tarjeton = (itm === null || itm === void 0 ? void 0 : (ref14 = itm.extraData) === null || ref14 === void 0 ? void 0 : ref14.length) && ((ref15 = itm === null || itm === void 0 ? void 0 : itm.extraData[0]) === null || ref15 === void 0 ? void 0 : ref15.value) ? (ref17 = JSON.parse((ref16 = itm === null || itm === void 0 ? void 0 : itm.extraData[0]) === null || ref16 === void 0 ? void 0 : ref16.value).find(function(itm) {
        return itm.name == "A\xf1adir una tarjeta personalizada";
    })) === null || ref17 === void 0 ? void 0 : ref17.value : "";
    // console.log("addedItems", addedItems);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: itm === null || itm === void 0 ? void 0 : (ref18 = itm.product) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.node) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.image) === null || ref20 === void 0 ? void 0 : ref20.mediaItemUrl
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "details",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                element: "h3",
                                children: itm === null || itm === void 0 ? void 0 : (ref21 = itm.product) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.node) === null || ref22 === void 0 ? void 0 : ref22.name
                            }),
                            (itm === null || itm === void 0 ? void 0 : (ref23 = itm.product) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.node) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.attributes) === null || ref25 === void 0 ? void 0 : ref25.nodes) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                element: "span",
                                className: "title"
                            }) : null,
                            isEBox ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                element: "p",
                                style: {
                                    fontSize: 11
                                },
                                children: "EXPERIENCE BOX"
                            }) : null,
                            isEBox && (addedItems === null || addedItems === void 0 ? void 0 : addedItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "adicionales",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "p",
                                        className: "complementos",
                                        children: t("queIncluye")
                                    }),
                                    addedItems.map(function(itm, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                            element: "span",
                                            style: {
                                                fontSize: 13
                                            },
                                            children: itm
                                        });
                                    })
                                ]
                            }) : null,
                            personalizacion || tarjeton ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "p",
                                        className: "gold",
                                        children: t("queIncluye")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "span",
                                        style: {
                                            fontSize: 13,
                                            lineHeight: 1.3,
                                            fontFamily: "GT Eesti",
                                            fontWeight: 300
                                        },
                                        children: "".concat(t("personalizacion"), ": <strong>").concat(personalizacion, "</strong>")
                                    }),
                                    tarjeton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "span",
                                        style: {
                                            fontSize: 13,
                                            lineHeight: 1.3,
                                            fontFamily: "GT Eesti",
                                            fontWeight: 300,
                                            marginTop: 5
                                        },
                                        children: "".concat(t("tarjeton"), ":  <strong>").concat(tarjeton, "</strong>")
                                    }) : null
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    " ",
                                    isEBox ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "link"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_quantity_picker_src/* default */.Z, {
                                        quantity: itm.quantity,
                                        setQuantity: function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
                                                var ref, ref1, ref2, ref3, ref4, tempExtraData;
                                                return runtime_default().wrap(function _callee$(_ctx) {
                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                        case 0:
                                                            ;
                                                            tempExtraData = itm === null || itm === void 0 ? void 0 : (ref = itm.extraData) === null || ref === void 0 ? void 0 : ref[0].value;
                                                            if (tempExtraData) {
                                                                tempExtraData = JSON.parse(tempExtraData);
                                                            }
                                                            if (!(parseInt(e) <= parseInt(itm === null || itm === void 0 ? void 0 : (ref1 = itm.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.node) === null || ref2 === void 0 ? void 0 : ref2.stockQuantity) || itm.quantity > e || !(itm === null || itm === void 0 ? void 0 : (ref3 = itm.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.node) === null || ref4 === void 0 ? void 0 : ref4.manageStock))) {
                                                                _ctx.next = 10;
                                                                break;
                                                            }
                                                            ;
                                                            _ctx.next = 7;
                                                            return handleQtyChange(itm, e, null, JSON.stringify({
                                                                addons: tempExtraData
                                                            })).then((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                                return runtime_default().wrap(function _callee$(_ctx) {
                                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                                        case 0:
                                                                            if (!(personalizacion && e == 0)) {
                                                                                _ctx.next = 3;
                                                                                break;
                                                                            }
                                                                            _ctx.next = 3;
                                                                            return handleQtyChangePersonalizacion(itm, -1, null);
                                                                        case 3:
                                                                        case "end":
                                                                            return _ctx.stop();
                                                                    }
                                                                }, _callee);
                                                            })));
                                                        case 7:
                                                            setStockError(false);
                                                            _ctx.next = 11;
                                                            break;
                                                        case 10:
                                                            {
                                                                setStockError(true);
                                                            }
                                                        case 11:
                                                        case "end":
                                                            return _ctx.stop();
                                                    }
                                                }, _callee);
                                            }));
                                            return function(e) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }(),
                                        allowZero: true,
                                        disabled: isPersonalizacion,
                                        i18n: i18n
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "h4",
                                        children: "".concat(numeral_default()((itm === null || itm === void 0 ? void 0 : (ref26 = itm.extraData) === null || ref26 === void 0 ? void 0 : ref26[0].value) != "[]" ? numeral_default()(itm.subtotal).value() + numeral_default()(itm.subtotalTax).value() : numeral_default()(itm === null || itm === void 0 ? void 0 : (ref27 = itm.product) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.node) === null || ref28 === void 0 ? void 0 : ref28.price).value() * itm.quantity).format("1,000.00$"))
                                    })
                                ]
                            }),
                            stockError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "stock-error-text",
                                children: t("no-hay-stock")
                            }) : null,
                            !isPersonalizacion ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return handleQtyChange(itm, -(itm === null || itm === void 0 ? void 0 : itm.quantity)).then((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                if (!personalizacion) {
                                                                    _ctx.next = 3;
                                                                    break;
                                                                }
                                                                _ctx.next = 3;
                                                                return handleQtyChangePersonalizacion(itm, -(itm === null || itm === void 0 ? void 0 : itm.quantity), null);
                                                            case 3:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                })));
                                            case 2:
                                                return _ctx.abrupt("return", _ctx.sent);
                                            case 3:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                })),
                                children: "X"
                            }) : null
                        ]
                    })
                ]
            }),
            isEBox && (addedItems === null || addedItems === void 0 ? void 0 : addedItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "adicionales-mobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "p",
                        className: "complementos",
                        children: "\xbfQu\xe9 incluye?"
                    }),
                    addedItems.map(function(itm, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                            element: "span",
                            style: {
                                fontSize: 13
                            },
                            children: itm
                        });
                    })
                ]
            }) : null,
            isEBox ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/info.png",
                        width: 20,
                        height: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                            element: "span",
                            style: {
                                fontSize: 11,
                                color: "#a79669",
                                fontFamily: "GT Eesti",
                                fontWeight: 300
                            },
                            children: t("infobeneficiario")
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var src_CartItem = (CartItem);

// EXTERNAL MODULE: ../packages/ab-cart/src/ab-cart.scss
var ab_cart = __webpack_require__(9691);
;// CONCATENATED MODULE: ../packages/ab-cart/src/index.tsx
















var Cart = function(param) {
    var anadir = param.anadir, anadirProductos = param.anadirProductos, cestaVacia = param.cestaVacia, codigoDescuento = param.codigoDescuento, continuarComprando = param.continuarComprando, descuento = param.descuento, eliminar = param.eliminar, falloPago = param.falloPago, finalizarCompra = param.finalizarCompra, intentarDeNuevo = param.intentarDeNuevo, introducirCodigo = param.introducirCodigo, iva = param.iva, portes = param.portes, portesQuedaX = param.portesQuedaX, titulo = param.titulo, failed = param.failed, i18n = param.i18n;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,src/* useCartContext */.iQ)(), 2), state = ref11[0], dispatch = ref11[1];
    var appliedCoupons = state.appliedCoupons, contents = state.contents, total = state.total, shippingTotal = state.shippingTotal, shippingTax = state.shippingTax, totalTax = state.totalTax, loaded = state.loaded, errorCoupon = state.errorCoupon;
    var applyCouponToCart = dispatch.applyCouponToCart, removeCouponFromCart = dispatch.removeCouponFromCart, addItemsToCart = dispatch.addItemsToCart, refreshCart = dispatch.refreshCart;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,ab_context_user_src/* useUserContext */.SE)(), 2), stateUser = ref12[0], dispatchUser = ref12[1];
    var role = stateUser.role;
    (0,react.useEffect)(function() {
        refreshCart();
    }, []);
    var ref13 = (0,react.useState)(""), coupon = ref13[0], setCoupon = ref13[1];
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    if ((numeral_default()).locales.abadia === undefined) {
        numeral_default().register("locale", "abadia", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mm",
                billion: "b",
                trillion: "t"
            },
            ordinal: function ordinal(number) {
                var b = number % 10;
                return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
            },
            currency: {
                symbol: "€"
            }
        });
    }
    numeral_default().locale("abadia");
    // console.log("Cart detail", totalTax);
    var totalForFreeShipping = role == "Personal" ? 50 : 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-cart",
        children: [
            (contents === null || contents === void 0 ? void 0 : (ref = contents.nodes) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                element: "h2",
                children: titulo
            }) : null,
            (contents === null || contents === void 0 ? void 0 : (ref1 = contents.nodes) === null || ref1 === void 0 ? void 0 : ref1.length) && failed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "span",
                        className: "title",
                        style: {
                            marginTop: 8,
                            width: "100%",
                            maxWidth: 590
                        },
                        children: falloPago
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: t("/finalizar-compra"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: function() {
                                if (failed) {
                                    addItemsToCart(state);
                                }
                            },
                            children: intentarDeNuevo
                        })
                    })
                ]
            }) : null,
            loaded && !(contents === null || contents === void 0 ? void 0 : (ref2 = contents.nodes) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "empty-cart",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "h2",
                        children: cestaVacia
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: t("/tienda"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: continuarComprando
                        })
                    })
                ]
            }) : loaded ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(ook_loading_src/* default */.Z, {
                loading: true
            }),
            ((contents === null || contents === void 0 ? void 0 : (ref3 = contents.nodes) === null || ref3 === void 0 ? void 0 : ref3.length) || 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(src_CartInfoShipping, {
                language: i18n === null || i18n === void 0 ? void 0 : i18n.language
            }),
            contents === null || contents === void 0 ? void 0 : (ref4 = contents.nodes) === null || ref4 === void 0 ? void 0 : ref4.map(function(itm) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(src_CartItem, {
                    itm: itm,
                    i18n: i18n
                }, itm === null || itm === void 0 ? void 0 : itm.key);
            }),
            (contents === null || contents === void 0 ? void 0 : (ref5 = contents.nodes) === null || ref5 === void 0 ? void 0 : ref5.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row coupon",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        width: "22",
                        height: "22",
                        viewBox: "0 0 22 22",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                id: "mask0",
                                style: {
                                    maskType: "alpha"
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "1",
                                y: "1",
                                width: "20",
                                height: "20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M1.83398 1.8335H20.1698V20.1677H1.83398V1.8335Z",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                mask: "url(#mask0)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M10.0333 18.4026C10.5741 18.9306 11.445 18.9242 11.9821 18.3843L12.644 17.7243C13.1573 17.2119 13.8668 16.9194 14.5901 16.9194H15.5342C16.2987 16.9194 16.9202 16.2979 16.9202 15.5344V14.5911C16.9202 13.8569 17.2044 13.1666 17.7232 12.6469L18.3832 11.9859C18.6518 11.7164 18.7957 11.3672 18.7948 10.9969C18.7939 10.6274 18.6481 10.28 18.3851 10.0179L17.7241 9.35602C17.2044 8.8326 16.9202 8.14327 16.9202 7.40902V6.4676C16.9202 5.7031 16.2987 5.0816 15.5342 5.0816H14.5919C13.8576 5.0816 13.1674 4.79652 12.6476 4.28043L11.9858 3.61768C11.4349 3.07227 10.5558 3.07502 10.0177 3.61677L9.35865 4.27768C8.83248 4.79743 8.14223 5.0816 7.41073 5.0816H6.46748C5.7039 5.08252 5.0824 5.70402 5.0824 6.4676V7.40718C5.0824 8.14143 4.79731 8.83168 4.28031 9.35235L3.62948 10.0041C3.62306 10.0114 3.61665 10.0169 3.61023 10.0234C3.07215 10.5651 3.0749 11.4442 3.61665 11.9823L4.27848 12.6441C4.79731 13.1648 5.0824 13.855 5.0824 14.5893V15.5344C5.0824 16.2979 5.70298 16.9194 6.46748 16.9194H7.4089C8.14406 16.9204 8.83431 17.2054 9.35406 17.7234L10.015 18.3824C10.0205 18.3889 10.0269 18.3953 10.0333 18.4026ZM10.9995 20.1681C10.2964 20.1681 9.59331 19.9023 9.05523 19.3688C9.0479 19.3614 9.04056 19.3541 9.03323 19.3459L8.3824 18.6959C8.12298 18.4384 7.77648 18.2954 7.40798 18.2944H6.46748C4.9449 18.2944 3.7074 17.056 3.7074 15.5344V14.5893C3.7074 14.2208 3.56348 13.8752 3.30498 13.6149L2.6459 12.9567C1.57523 11.8915 1.5624 10.1572 2.61381 9.07552C2.62206 9.06727 2.63031 9.05902 2.63856 9.05077L3.3059 8.3816C3.56348 8.12218 3.7074 7.77477 3.7074 7.40718V6.4676C3.7074 4.94593 4.9449 3.70752 6.46656 3.7066H7.41073C7.77831 3.7066 8.12481 3.56268 8.3879 3.30327L9.04331 2.64602C10.1149 1.5671 11.8666 1.5616 12.9474 2.63593L13.6175 3.30602C13.8769 3.5636 14.2234 3.7066 14.5919 3.7066H15.5342C17.0568 3.7066 18.2952 4.94502 18.2952 6.4676V7.40902C18.2952 7.7766 18.4382 8.12402 18.6976 8.38527L19.3558 9.04435C19.8774 9.56227 20.1671 10.2544 20.1698 10.9923C20.1726 11.7302 19.8875 12.4241 19.3677 12.9475L18.6958 13.6176C18.4382 13.877 18.2952 14.2226 18.2952 14.5911V15.5344C18.2952 17.056 17.0568 18.2944 15.5351 18.2944H14.5901C14.2271 18.2944 13.8723 18.4411 13.6147 18.6969L12.9566 19.355C12.4185 19.8968 11.709 20.1681 10.9995 20.1681Z",
                                    fill: "#372F2F"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M8.6443 14.0446C8.4683 14.0446 8.2923 13.9777 8.15847 13.843C7.88989 13.5744 7.88989 13.1399 8.15847 12.8713L12.8701 8.15871C13.1387 7.89013 13.5741 7.89013 13.8427 8.15871C14.1113 8.4273 14.1113 8.86271 13.8427 9.1313L9.13014 13.843C8.9963 13.9777 8.8203 14.0446 8.6443 14.0446Z",
                                fill: "#372F2F"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M13.2963 14.2076C12.7893 14.2076 12.375 13.7979 12.375 13.2909C12.375 12.784 12.7811 12.3743 13.288 12.3743H13.2963C13.8032 12.3743 14.2129 12.784 14.2129 13.2909C14.2129 13.7979 13.8032 14.2076 13.2963 14.2076Z",
                                fill: "#372F2F"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M8.71227 9.62435C8.20535 9.62435 7.79102 9.2146 7.79102 8.70768C7.79102 8.20077 8.1971 7.79102 8.70402 7.79102H8.71227C9.21918 7.79102 9.62893 8.20077 9.62893 8.70768C9.62893 9.2146 9.21918 9.62435 8.71227 9.62435Z",
                                fill: "#372F2F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "span",
                        className: "title",
                        children: codigoDescuento
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                        placeholder: introducirCodigo,
                        value: (appliedCoupons === null || appliedCoupons === void 0 ? void 0 : (ref6 = appliedCoupons[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.code) === null || ref7 === void 0 ? void 0 : ref7.toUpperCase()) || coupon,
                        onChange: function(val) {
                            return setCoupon(val);
                        },
                        error: errorCoupon == "error" ? t("cupon-no-encontrado") : "",
                        disabled: appliedCoupons
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: !coupon,
                        onClick: appliedCoupons ? function() {
                            var ref;
                            removeCouponFromCart(appliedCoupons === null || appliedCoupons === void 0 ? void 0 : (ref = appliedCoupons[0]) === null || ref === void 0 ? void 0 : ref.code);
                            setCoupon("");
                        } : function() {
                            return applyCouponToCart(coupon);
                        },
                        children: appliedCoupons ? eliminar : anadir
                    })
                ]
            }) : null,
            appliedCoupons === null || appliedCoupons === void 0 ? void 0 : appliedCoupons.map(function(itm) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                            element: "span",
                            className: "title",
                            children: descuento
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                            element: "span",
                            className: "title gold",
                            children: itm.code.toUpperCase()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                            element: "span",
                            className: "title",
                            children: "-".concat(numeral_default()(numeral_default()(itm.discountAmount).value() + numeral_default()(itm.discountTax).value()).format("1,000.00$"))
                        })
                    ]
                });
            }),
            (contents === null || contents === void 0 ? void 0 : (ref8 = contents.nodes) === null || ref8 === void 0 ? void 0 : ref8.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "span",
                        className: "title",
                        children: portes
                    }),
                    numeral_default()(shippingTotal).value() + numeral_default()(shippingTax).value() != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                            element: "span",
                            className: "title gold",
                            children: "".concat(portesQuedaX === null || portesQuedaX === void 0 ? void 0 : portesQuedaX.replace("${amount}", numeral_default()(totalForFreeShipping - numeral_default()(total).value()).format("1,000.00$")))
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "span",
                        className: "title",
                        children: "".concat(numeral_default()(numeral_default()(shippingTotal).value() + numeral_default()(shippingTax).value()).format("1,000.00$"))
                    })
                ]
            }) : null,
            (contents === null || contents === void 0 ? void 0 : (ref9 = contents.nodes) === null || ref9 === void 0 ? void 0 : ref9.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "total",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "span",
                        className: "title",
                        children: "Total"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "h3",
                        children: numeral_default()(total).format("1,000.00$")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "span",
                        className: "title",
                        style: {
                            width: "100%"
                        },
                        children: iva === null || iva === void 0 ? void 0 : iva.replace("${amount}", numeral_default()(totalTax).format("1,000.00$"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "span",
                        className: "title gold shipping-message",
                        children: t("envios-dentro-de-espana")
                    })
                ]
            }) : null,
            (contents === null || contents === void 0 ? void 0 : (ref10 = contents.nodes) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                        text: anadirProductos,
                        href: t("/tienda")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: t("/finalizar-compra"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: function() {
                                var ref;
                                (0,datalayer/* gtmSendCheckoutStep0 */.pc)(state === null || state === void 0 ? void 0 : (ref = state.contents) === null || ref === void 0 ? void 0 : ref.nodes);
                                if (failed) {
                                    addItemsToCart(state);
                                }
                            },
                            children: failed ? intentarDeNuevo : finalizarCompra
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var ab_cart_src = (Cart);


/***/ }),

/***/ 9215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ab_input_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78015);
/* harmony import */ var _ab_input_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_input_scss__WEBPACK_IMPORTED_MODULE_3__);







var Input = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "text" : _type, value = _param.value, onChange = _param.onChange, className = _param.className, label = _param.label, placeholder = _param.placeholder, error = _param.error, parentClassName = _param.parentClassName, placeHolderClassname = _param.placeHolderClassname, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "type",
        "value",
        "onChange",
        "className",
        "label",
        "placeholder",
        "error",
        "parentClassName",
        "placeHolderClassname"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var renderInput = function() {
        if (parentClassName == "at-novartis") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : ""),
                        type: type,
                        value: value,
                        onChange: function(e) {
                            return onChange(e.target.value);
                        },
                        placeholder: placeholder
                    }, rest)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : ""),
                        type: type,
                        value:  true ? "@novartis.com" : 0,
                        placeholder: placeholder
                    }, rest), {
                        disabled: true
                    }))
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : "", " ").concat(placeHolderClassname || ""),
            type: showPassword ? "text" : type,
            value: value,
            onChange: function(e) {
                return type !== "checkbox" && type !== "radio" ? onChange(e.target.value) : onChange(e.target.checked);
            },
            checked: value,
            placeholder: placeholder
        }, rest));
    };
    // if (type == "text" || type == "password") {
    //   return renderInput();
    // }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "ab-input container ".concat(type, " ").concat(parentClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: label
            }),
            renderInput(),
            type == "password" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "password",
                role: "button",
                onClick: function() {
                    return setShowPassword(!showPassword);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: showPassword ? "/images/hide.png" : "/images/show.png",
                    style: {
                        width: 16,
                        height: 16
                    },
                    alt: showPassword ? "hide" : "show"
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "checkmark"
            }),
            error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "error",
                children: error
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 9691:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 78015:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);